import * as React from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IGreenCheckMarkWithWhiteBgProps {}
export const GreenCheckMarkWithWhiteBg: React.FunctionComponent<IGreenCheckMarkWithWhiteBgProps> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="43" height="42" fill="none" viewBox="0 0 43 42" {...props}>
      <path
        stroke="#0E9F6E"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M16.25 21l3.5 3.5 7-7m10.5 3.5a15.75 15.75 0 11-31.501 0 15.75 15.75 0 0131.501 0z"
      ></path>
    </svg>
  );
};

export default GreenCheckMarkWithWhiteBg;
